<template>
  <div
    class="d-flex flex-column"
  >
    <RebondAbonnement
      v-if="!abonnements.culturialAbonne"
      :class="$vuetify.breakpoint.mobile ? '' :'position-rebond'"
    />
    <img
      alt="no-comparaison"
      class="mt-4 align-self-center"
      src="@/assets/no-comparaison.svg"
    >
    <v-chip
      v-if="isDisplayNouveaute && $vuetify.breakpoint.mobile"
      color="#DBBD00"
      label
      small
      class="texte align-self-start"
    >
      <span class="white--text">Nouveau</span>
    </v-chip>
    <div
      class="d-flex"
      :class="$vuetify.breakpoint.mobile ? '' : ' justify-center '"
    >
      <div class="titre-h1 align-self-center">
        Comparateur de marges
      </div>
      <div class="align-self-center ml-3">
        <v-icon
          @click="isOpenModalHelp = true"
        >
          mdi-information-outline
        </v-icon>
      </div>
      <v-chip
        v-if="isDisplayNouveaute && !$vuetify.breakpoint.mobile"
        color="#DBBD00"
        label
        small
        class="texte align-self-center ml-3"
      >
        <span class="white--text">Nouveau</span>
      </v-chip>
    </div>
    <div
      class="d-flex intro texte-gris-fonce"
      :class="$vuetify.breakpoint.mobile ? '' : ' justify-center '"
    >
      {{ $vuetify.breakpoint.mobile ? 'Sélectionner 2 graines à comparer' : 'Sélectionner jusqu\'à 3 graines à comparer' }}
    </div>
    <div
      class="d-flex justify-center mt-6 mb-3"
      :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
    >
      <div
        v-if="isDisplayComparaison"
        class="align-self-center fixed-width"
        :class="$vuetify.breakpoint.mobile ? 'pl-4 pb-4' : ''"
      >
        <div
          class="texte texte-gris-fonce"
        >
          <v-icon
            color="primary"
            @click="isConfirmDeleteModalOpen = true"
          >
            mdi-reload
          </v-icon>
          <span
            class="btn-reinit"
            @click="isConfirmDeleteModalOpen = true"
          > Réinitialiser l'outil</span>
        </div>
      </div>
      <div class="d-flex">
        <div
          class="fixed-width"
          :class="$vuetify.breakpoint.mobile ? 'pl-0' : 'px-3'"
        >
          <v-select
            v-model="cultureUneSelected"
            :items="culturesUneFiltrees"
            item-text="nom"
            :label="cultureUneSelected!= null ? '' : $vuetify.breakpoint.mobile ? 'Graine' : 'Choisir une graine'"
            outlined
            :menu-props="{ bottom: true, offsetY: true }"
            return-object
            hide-details
            @change="selectCulture()"
          >
            <template v-slot:prepend-inner>
              <v-img
                alt="picto-graine"
                class="picto-graine"
                src="@/assets/graine.svg"
              />
            </template>
            <template v-slot:item="{item}">
              <div class="intro">
                {{ item.nom }}
              </div>
            </template>
            <template v-slot:selection="{item}">
              <div class="intro">
                {{ item.nom }}
              </div>
            </template>
          </v-select>
        </div>
        <div
          class="fixed-width"
          :class="$vuetify.breakpoint.mobile ? 'pl-1' : 'px-3'"
        >
          <v-select
            v-model="cultureDeuxSelected"
            :items="culturesDeuxFiltrees"
            item-text="nom"
            :label="cultureDeuxSelected!= null ? '' : $vuetify.breakpoint.mobile ? 'Graine' : 'Choisir une graine'"
            outlined
            :menu-props="{ bottom: true, offsetY: true }"
            hide-details
            return-object
            @change="selectCulture()"
          >
            <template v-slot:prepend-inner>
              <v-img
                alt="picto-graine"
                class="picto-graine"
                src="@/assets/graine.svg"
              />
            </template>
            <template v-slot:item="{item}">
              <div class="intro">
                {{ item.nom }}
              </div>
            </template>
            <template v-slot:selection="{item}">
              <div class="intro">
                {{ item.nom }}
              </div>
            </template>
          </v-select>
        </div>
        <div
          v-if="!$vuetify.breakpoint.mobile"
          class="fixed-width px-3"
        >
          <v-select
            v-model="cultureTroisSelected"
            :items="culturesTroisFiltrees"
            item-text="nom"
            :label="cultureTroisSelected!= null ? '' : 'Choisir une graine'"
            outlined
            :menu-props="{ bottom: true, offsetY: true }"
            hide-details
            return-object
            @change="selectCulture()"
          >
            <template v-slot:prepend-inner>
              <v-img
                alt="picto-graine"
                class="picto-graine"
                src="@/assets/graine.svg"
              />
            </template>
            <template v-slot:item="{item}">
              <div class="intro">
                {{ item.nom }}
              </div>
            </template>
            <template v-slot:selection="{item}">
              <div class="intro">
                {{ item.nom }}
              </div>
            </template>
          </v-select>
        </div>
      </div>
    </div>
    <div
      v-if="!isDisplayComparaison"
      class="d-flex justify-center"
    >
      <AgrButton
        color="primary darken-1"
        large
        :block="$vuetify.breakpoint.mobile"
        :disabled="!isComparaisonPossible"
        @click="displayComparaisonMarge()"
      >
        <span
          class="action white--text"
        >Comparer les marges</span>
      </AgrButton>
    </div>
    <div
      v-if="!isDisplayComparaison"
      class="mt-5 d-flex justify-center intro"
    >
      <div
        class="texte primary--text"
      >
        <v-icon
          color="primary"
          @click="isOpenModalBesoinAideInformationAbonnement = true"
        >
          mdi-information-outline
        </v-icon>
        <span
          class="btn-reinit"
          @click="isOpenModalBesoinAideInformationAbonnement = true"
        > Besoin d'aide ?</span>
      </div>
    </div>
    <BaseLoader v-if="loading" />
    <BaseMessageServerError v-if="erreur" />
    <span
      v-if="isDisplayComparaison && isComparaisonPossible && !loading"
      class="mb-10"
    >
      <div>
        <v-divider class="mx-3" />
        <div
          class="d-flex"
          :class="$vuetify.breakpoint.mobile ? '' : 'ml-3 pb-3'"
        >
          <img
            alt="no-comparaison"
            class="align-self-center mt-6 mr-4"
            src="@/assets/chiffre-1.svg"
          >
          <span
            class="mt-6 align-self-center secondary--text"
            :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3 '"
          >Produit de la culture</span>
        </div>

        <div>
          <!-- PRODUITS -->
          <div
            v-for="(produit, index) in produits"
            :key="index"
          >
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-center fixed-height'"
            >
              <div
                class="intro text-gris-fonce"
                :class="$vuetify.breakpoint.mobile ? 'pt-3' : 'pl-2 align-self-center fixed-width'"
              >
                {{ produit[0].comparateurMargeParametre.typeRubrique.libelleSousRubrique }}
                <span
                  v-if="produit[0].comparateurMargeParametre.typeRubrique.libelleSousRubrique === 'Rendement'"
                >{{ computeUniteRendement ? '('+ computeUniteRendement + ')' : null }}</span>
                <span
                  v-else
                  class="intro text-gris-fonce"
                > ({{ produit[0].comparateurMargeParametre.typeRubrique.unite }})</span>
              </div>
              <div class="d-flex">
                <span
                  v-for="(produitParGraine, indexP) in produit"
                  :key="produitParGraine.id"
                  class="align-self-center"
                  :class="$vuetify.breakpoint.mobile ? 'w-100' : 'px-2 fixed-width'"
                >
                  <div
                    v-if="($vuetify.breakpoint.mobile && indexP <=1 ) || !$vuetify.breakpoint.mobile"
                    :class="$vuetify.breakpoint.mobile ? 'px-1' : ''"
                  >
                    <div
                      v-if="produitParGraine && produitParGraine.comparateurMargeParametre && produitParGraine.comparateurMargeParametre.id && produitParGraine.comparateurMargeParametre.typeRubrique && produitParGraine.comparateurMargeParametre.typeRubrique.libelleSousRubrique !== 'Aides couplées'"
                    >
                      <BaseInputNumberIncrement
                        :class="$vuetify.breakpoint.mobile ? 'px-1 text-truncate max-width-165' : ''"
                        :object-value="produitParGraine.comparateurMargeParametre.valeurAdmin"
                        :min="produitParGraine.comparateurMargeParametre.valeurAdmin.minimum"
                        :max="produitParGraine.comparateurMargeParametre.valeurAdmin.maximum"
                        :is-lock="!abonnements.culturialAbonne"
                        :is-disabled="!($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess())"
                        :has-same-value="hasSameValue(produitParGraine.comparateurMargeParametre)"
                        :has-droit-ecriture="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess())"
                        :has-erreur-saisie="hasErreurSaisie(produitParGraine)"
                        :msg-info-mais-grain="getMsgInfoMaisGrainOuSorgo(produitParGraine, produitParGraine.comparateurMargeParametre.typeRubrique.libelleSousRubrique)"
                        :unite="produitParGraine.comparateurMargeParametre.typeRubrique.libelleSousRubrique === 'Rendement' && computeUniteRendement === null ? uniteRendement(produitParGraine.comparateurMargeParametre.typeCulture) : null"
                        @update="onUpdate($event, produitParGraine)"
                        @openModalAbonnement="openModalAbonnement"
                      />
                    </div>
                    <div
                      v-else
                      class="intro text-gris-fonce "
                      :class="$vuetify.breakpoint.mobile ? 'max-width-165 mt-2' : 'fixed-width'"
                    >
                      <div
                        class="align-center"
                      >
                        {{
                          produitParGraine.comparateurMargeParametre.valeurDefaut
                            ?
                              produitParGraine.comparateurMargeParametre.valeurDefaut
                            :
                              produitParGraine.comparateurMargeParametre.typeCulture ? '-' : ''
                        }}
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <v-card
            color="primary"
            elevation="0"
            class="py-3 mt-3"
          >
            <BandeauTotaux
              libelle="Total produits (€/ha)"
              :valeurs="adherentComparateurMarge ? adherentComparateurMarge.totauxProduitCultures : null"
              :has-loading="hasLoadingProduit"
              :has-erreur="hasErreurProduit"
            />
          </v-card>
          <v-divider class="mx-3 mt-8" />
          <div
            class="d-flex"
            :class="$vuetify.breakpoint.mobile ? '' : 'ml-3 pb-3'"
          >
            <img
              alt="no-comparaison"
              class="align-self-center mt-6 mr-4"
              src="@/assets/chiffre-2.svg"
            >
            <span
              class="mt-6 align-self-center secondary--text"
              :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3 '"
            >Itinéraire technique</span>
          </div>
          <!-- ITINERAIRE TECHNIQUE -->
          <div
            class="d-flex"
            :class="$vuetify.breakpoint.mobile ? 'flex-column ' : 'justify-center fixed-height'"
          >
            <div
              class="intro text-gris-fonce"
              :class="$vuetify.breakpoint.mobile ? '' : 'pl-2 align-self-center fixed-width'"
            >
              Densité de semis {{ computeUniteDensiteSemis ? '('+ computeUniteDensiteSemis + ')' : null }}
            </div>
            <div class="d-flex">
              <div :class="$vuetify.breakpoint.mobile ? 'px-1' : 'px-1 align-self-center fixed-width'">
                <div
                  v-if="densiteSemis[0].comparateurMargeParametre.valeurAdmin"
                  :class="$vuetify.breakpoint.mobile ? 'text-truncate max-width-165' : ''"
                >
                  <BaseInputNumberIncrement
                    :object-value="densiteSemis[0].comparateurMargeParametre.valeurAdmin"
                    :min="densiteSemis[0].comparateurMargeParametre.valeurAdmin.minimum"
                    :max="densiteSemis[0].comparateurMargeParametre.valeurAdmin.maximum"
                    :is-lock="!abonnements.culturialAbonne"
                    :is-disabled="!($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess())"
                    :has-same-value="hasSameValue(densiteSemis[0].comparateurMargeParametre)"
                    :has-droit-ecriture="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess())"
                    :has-erreur-saisie="hasErreurSaisie(densiteSemis[0])"
                    :unite="densiteSemis[0].comparateurMargeParametre.typeRubrique.codeRubrique === 'DENSITE_SEMIS' && computeUniteDensiteSemis === null ? densiteSemis[0].comparateurMargeParametre.unite : null"
                    @update="onUpdate($event, densiteSemis[0])"
                    @openModalAbonnement="openModalAbonnement"
                  />
                </div>
                <div
                  v-else
                  class="intro text-gris-fonce align-self-center"
                >
                  <div class="align-center">{{ cultureUneSelected != null ? '-' : '' }}</div>
                </div>
              </div>
              <div :class="$vuetify.breakpoint.mobile ? 'px-1' : 'px-1 align-self-center fixed-width'">
                <div
                  v-if="densiteSemis[1].comparateurMargeParametre.valeurAdmin"
                  :class="$vuetify.breakpoint.mobile ? 'text-truncate max-width-165' : ''"
                >
                  <BaseInputNumberIncrement
                    :object-value="densiteSemis[1].comparateurMargeParametre.valeurAdmin"
                    :min="densiteSemis[1].comparateurMargeParametre.valeurAdmin.minimum"
                    :max="densiteSemis[1].comparateurMargeParametre.valeurAdmin.maximum"
                    :is-lock="!abonnements.culturialAbonne"
                    :is-disabled="!($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) || hasSameValue(densiteSemis[1].comparateurMargeParametre)"
                    :has-same-value="hasSameValue(densiteSemis[1].comparateurMargeParametre)"
                    :has-droit-ecriture="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess())"
                    :has-erreur-saisie="hasErreurSaisie(densiteSemis[1])"
                    :unite="densiteSemis[1].comparateurMargeParametre.typeRubrique.codeRubrique === 'DENSITE_SEMIS' && computeUniteDensiteSemis === null ? densiteSemis[1].comparateurMargeParametre.unite : null"
                    @update="onUpdate($event, densiteSemis[1])"
                    @openModalAbonnement="openModalAbonnement"
                  />
                </div>
                <div
                  v-else
                  class="intro text-gris-fonce align-self-center"
                >
                  <div class="align-center">{{ cultureDeuxSelected != null ? '-' : '' }}</div>
                </div>
              </div>
              <div
                v-if="!$vuetify.breakpoint.mobile"
                class="px-1 align-self-center fixed-width"
              >
                <div
                  v-if="densiteSemis[2].comparateurMargeParametre.valeurAdmin"
                >
                  <BaseInputNumberIncrement
                    :object-value="densiteSemis[2].comparateurMargeParametre.valeurAdmin"
                    :min="densiteSemis[2].comparateurMargeParametre.valeurAdmin.minimum"
                    :max="densiteSemis[2].comparateurMargeParametre.valeurAdmin.maximum"
                    :is-lock="!abonnements.culturialAbonne"
                    :is-disabled="!($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) || hasSameValue(densiteSemis[2].comparateurMargeParametre)"
                    :has-same-value="hasSameValue(densiteSemis[2].comparateurMargeParametre)"
                    :has-droit-ecriture="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess())"
                    :has-erreur-saisie="hasErreurSaisie(densiteSemis[2])"
                    :unite="densiteSemis[2].comparateurMargeParametre.typeRubrique.codeRubrique === 'DENSITE_SEMIS' && computeUniteDensiteSemis === null ? densiteSemis[2].comparateurMargeParametre.unite : null"
                    @update="onUpdate($event, densiteSemis[2])"
                    @openModalAbonnement="openModalAbonnement"
                  />
                </div>
                <div
                  v-else
                  class="intro text-gris-fonce align-self-center fixed-width"
                >
                  <div class="align-center">{{ cultureTroisSelected != null ? '-' : '' }}</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-center fixed-height'"
            >
              <div
                class="intro text-gris-fonce"
                :class="$vuetify.breakpoint.mobile ? 'pt-3' : 'pl-2 align-self-center fixed-width'"
              >
                Engrais (unités)
 
              </div>
              <div class="d-flex">
                <CelluleModifiable
                  :valeur="computeEngraisCultureUne"
                  :en-erreur="hasErreurSaisie(engraisCultureUne)"
                  @modifier="changeEngrais(engraisCultureUne)"
                />
                <CelluleModifiable
                  :valeur="computeEngraisCultureDeux"
                  :en-erreur="hasErreurSaisie(engraisCultureDeux)"
                  @modifier="changeEngrais(engraisCultureDeux)"
                />
                <CelluleModifiable
                  v-if="!$vuetify.breakpoint.mobile"
                  :valeur="computeEngraisCultureTrois"
                  :en-erreur="hasErreurSaisie(engraisCultureTrois)"
                  @modifier="changeEngrais(engraisCultureTrois)"
                />
                <div
                  v-else
                  class="intro text-gris-fonce "
                  :class="$vuetify.breakpoint.mobile ? '' : 'fixed-width'"
                >
                  <div
                    class="align-center"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-center fixed-height'"
            >
              <div
                class="intro text-gris-fonce"
                :class="$vuetify.breakpoint.mobile ? 'pb-2' : 'pl-2 align-self-center fixed-width'"
              >
                Traitements
 
              </div>
              <div class="d-flex">
                <CelluleModifiable
                  v-if="cultureUneSelected"
                  :valeur="traitements[0]"
                  :en-erreur="hasErreurSaisie(traitementsCultureUne)"
                  @modifier="changeTraitement(traitementsCultureUne, adherentComparateurMargeModifiable.libellesMoyennePressionsTraitementCultures[0])"
                />
                <div
                  v-else
                  class="intro text-gris-fonce align-self-center fixed-width"
                >
                  <div class="align-center" />
                </div>
                <CelluleModifiable
                  v-if="cultureDeuxSelected"
                  :valeur="traitements[1]"
                  :en-erreur="hasErreurSaisie(traitementsCultureDeux)"
                  @modifier="changeTraitement(traitementsCultureDeux, adherentComparateurMargeModifiable.libellesMoyennePressionsTraitementCultures[1])"
                />
                <div
                  v-else
                  class="intro text-gris-fonce align-self-center fixed-width"
                >
                  <div class="align-center" />
                </div>
                <CelluleModifiable
                  v-if="!$vuetify.breakpoint.mobile && cultureTroisSelected"
                  :valeur="traitements[2]"
                  :en-erreur="hasErreurSaisie(traitementsCultureTrois)"
                  @modifier="changeTraitement(traitementsCultureTrois, adherentComparateurMargeModifiable.libellesMoyennePressionsTraitementCultures[2])"
                />
                <div
                  v-else
                  class="intro text-gris-fonce align-self-center fixed-width"
                >
                  <div class="align-center" />
                </div>
              </div>
            </div>
          </div>
          <v-card
            color="primary"
            elevation="0"
            class="py-3"
          >
            <BandeauTotaux
              libelle="Total intrants (€/ha)"
              :valeurs="adherentComparateurMarge ? adherentComparateurMarge.totauxIntrantsCultures : null"
              :has-loading="hasLoadingDensite"
              :has-erreur="hasErreurIntrant"
            />
          </v-card>
          <v-divider class="mx-3 mt-8" />
          <div
            class="d-flex pb-3"
            :class="$vuetify.breakpoint.mobile ? '' : 'ml-3 '"
          >
            <img
              alt="no-comparaison"
              class="align-self-center mt-6 mr-4"
              src="@/assets/chiffre-3.svg"
            >
            <span
              class="mt-6 align-self-center secondary--text"
              :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3 '"
            >Charges spécifiques de la culture</span>
          </div>
          <!-- CHARGES SPECIFIQUES -->
          <ChargesSpecifiques
            :charges="autresChargesSpecifiques"
            :totaux="adherentComparateurMarge ? adherentComparateurMarge.totauxAutreChargeCultures : null"
            :has-erreur="hasErreurAutresCharges"
            :has-loading="hasLoadingAutresCharges"
            :param-erreur="paramErreur"
            :est-abonne="abonnements.culturialAbonne"
            :peut-modifier="$roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()"
            @update="onUpdate"
            @openModalAbonnement="openModalAbonnement"
          />
          <!-- MARGE -->
          <v-card
            id="marge"
            elevation="0"
            class="mt-8 border"
          >
            <div
              elevation="0"
              class="px-4 py-3 entete-marge"
            >
              <BandeauTotaux
                libelle="Marge brute (€/ha)"
                :valeurs="adherentComparateurMarge ? adherentComparateurMarge.margesBrutesCultures : null"
                :has-loading="hasLoadingMarge"
                :has-erreur="hasErreurMarge"
              />
            </div>
            <div>
              <div
                v-if="!hasAnyIndicateurNonCalculeRestitutionNutritive"
                class="d-flex"
                :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-center'"
              >
                <div
                  class="intro text-gris-fonce"
                  :class="$vuetify.breakpoint.mobile ? 'pt-2 pl-3' : 'pl-2 py-3 align-self-center fixed-width'"
                >
                  Restitution nutritive
 
                </div>
                <div class="d-flex">
                  <div
                    class="secondary--text titre-h4 fixed-width  align-center"
                    :class="$vuetify.breakpoint.mobile ? 'py-3' : 'align-self-center'"
                  >
                    <span v-if="indicateursNonChiffresCultureUne && Object.values(indicateursNonChiffresCultureUne.restitutionNutritive).length > 0">
                      {{ restitutionNutritiveCultureUne }}
                    </span>
                    <span v-else>-</span>
                  </div>
                  <div
                    class="py-3 secondary--text titre-h4 fixed-width align-center "
                    :class="$vuetify.breakpoint.mobile ? 'py-3' : 'align-self-center px-3'"
                  >
                    <span v-if="indicateursNonChiffresCultureDeux && Object.values(indicateursNonChiffresCultureDeux.restitutionNutritive).length > 0">
                      {{ restitutionNutritiveCultureDeux }}
                    </span>
                    <span v-else>-</span>
                  </div>
                  <div
                    v-if="!$vuetify.breakpoint.mobile"
                    class="secondary--text titre-h4 fixed-width align-center"
                    :class="$vuetify.breakpoint.mobile ? 'py-3' : 'align-self-center'"
                  >
                    <span v-if="indicateursNonChiffresCultureTrois && Object.values(indicateursNonChiffresCultureTrois.restitutionNutritive).length > 0">
                      {{ restitutionNutritiveCultureTrois }}
                    </span>
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
              <div
                class="d-flex"
                :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-center'"
              >
                <div
                  class="intro text-gris-fonce"
                  :class="$vuetify.breakpoint.mobile ? 'pl-3' : 'pl-2 py-3 align-self-center fixed-width'"
                >
                  PAC (Ecorégime) 
                </div>
                <div class="d-flex">
                  <div
                    class="secondary--text titre-h4 fixed-width  align-center"
                    :class="$vuetify.breakpoint.mobile ? 'py-3' : 'align-self-center'"
                  >
                    {{ indicateursNonChiffresCultureUne.indicateurNonChiffrePAC.nombrePointsPAC >= 0 ? indicateursNonChiffresCultureUne.indicateurNonChiffrePAC.nombrePointsPAC : '-' }} {{ indicateursNonChiffresCultureUne.indicateurNonChiffrePAC.nombrePointsPAC != null ? indicateursNonChiffresCultureUne.indicateurNonChiffrePAC.nombrePointsPAC > 1 ? 'points' : 'point' : '' }} {{ indicateursNonChiffresCultureUne.indicateurNonChiffrePAC.libellePAC ? '('+indicateursNonChiffresCultureUne.indicateurNonChiffrePAC.libellePAC +')' : '' }}
                  </div>
                  <div
                    class="py-3 secondary--text titre-h4 fixed-width align-center "
                    :class="$vuetify.breakpoint.mobile ? 'py-3' : 'align-self-center px-3'"
                  >
                    {{ indicateursNonChiffresCultureDeux && indicateursNonChiffresCultureDeux.indicateurNonChiffrePAC.nombrePointsPAC >= 0 ? indicateursNonChiffresCultureDeux && indicateursNonChiffresCultureDeux.indicateurNonChiffrePAC.nombrePointsPAC : '-' }} {{ indicateursNonChiffresCultureDeux && indicateursNonChiffresCultureDeux.indicateurNonChiffrePAC.nombrePointsPAC != null ? indicateursNonChiffresCultureDeux && indicateursNonChiffresCultureDeux.indicateurNonChiffrePAC.nombrePointsPAC > 1 ? 'points' : 'point' : '' }} {{ indicateursNonChiffresCultureDeux && indicateursNonChiffresCultureDeux.indicateurNonChiffrePAC.libellePAC ? '('+indicateursNonChiffresCultureDeux.indicateurNonChiffrePAC.libellePAC +')' : '' }}
                  </div>
                  <div
                    v-if="!$vuetify.breakpoint.mobile"
                    class="secondary--text titre-h4 fixed-width align-center"
                    :class="$vuetify.breakpoint.mobile ? 'py-3' : 'align-self-center'"
                  >
                    {{ indicateursNonChiffresCultureTrois && indicateursNonChiffresCultureTrois.indicateurNonChiffrePAC.nombrePointsPAC >= 0 ? indicateursNonChiffresCultureTrois.indicateurNonChiffrePAC.nombrePointsPAC : '-' }} {{ indicateursNonChiffresCultureTrois && indicateursNonChiffresCultureTrois.indicateurNonChiffrePAC.nombrePointsPAC != null ? indicateursNonChiffresCultureTrois.indicateurNonChiffrePAC.nombrePointsPAC > 1 ? 'points' : 'point' : '' }} {{ indicateursNonChiffresCultureTrois && indicateursNonChiffresCultureTrois.indicateurNonChiffrePAC.libellePAC ? '('+indicateursNonChiffresCultureTrois.indicateurNonChiffrePAC.libellePAC +')' : '' }}
                  </div>
                </div>
              </div>
            </div>
          </v-card>
          <div class="d-flex justify-center intro texte-gris-fonce mt-10">
            Les coûts du comparateur sont standardisés
          </div>
          <div class="d-flex justify-center titre-h4 secondary--text my-4">
            Allez plus loin en affectant l'ensemble de vos charges
          </div>
          <div class="d-flex justify-center intro texte-gris-fonce">
            <AgrButton
              color="primary darken-1"
              large
              @click="isOpenModalCalculPrixDeRevientInformationAbonnement = true"
            >
              <span class="action white--text">
                Calculer mon prix d'équilibre
              </span>
            </AgrButton>
          </div>
          <!-- Marge fixée en bas de page -->
          <div
            v-show="isDisplayComparaison && isComparaisonPossible"
            id="marge-fixed"
            elevation="0"
            class="px-4 py-3 entete-marge"
            :class="[isDisplayMargeFixed ? '' : 'z-index-marge-fixed', $vuetify.breakpoint.mobile ? 'alert-fixed-mobile' : 'alert-fixed'] "
          >
            <BandeauTotaux
              libelle="Marge brute (€/ha)"
              :valeurs="adherentComparateurMarge ? adherentComparateurMarge.margesBrutesCultures : null"
              :has-loading="hasLoadingMarge"
              :has-erreur="hasErreurMarge"
            />
          </div>
        </div>
      </div>
    </span>
    <InformationAbonnementModal
      v-if="isOpenModalCalculPrixDeRevientInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalCalculPrixDeRevientInformationAbonnement"
      code-feature="PRIX_EQUILIBRE"
      :is-conseiller-pv-affiche="false"
      titre="Calculer votre prix d'équilibre"
      texte="Déterminez votre prix d'équilibre par culture en €/t grâce à un expert, pour vous aider dans votre commercialisation."
      @close="isOpenModalCalculPrixDeRevientInformationAbonnement = false"
    />
    <InformationAbonnementModal
      v-if="isOpenModalBesoinAideInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalBesoinAideInformationAbonnement"
      code-feature="COMPARATEUR_MARGE"
      titre="Besoin d'aide ?"
      texte=""
      @close="isOpenModalBesoinAideInformationAbonnement = false"
    />
    <InformationAbonnementModal
      v-if="isOpenModalInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalInformationAbonnement"
      code-feature="COMPARATEUR_MARGE"
      texte="Préparez votre prochain assolement en estimant le potentiel de marges selon le contexte de votre exploitation."
      titre="Comparateur de marges"
      @close="isOpenModalInformationAbonnement = false"
    />
    <HelpModal
      v-if="isOpenModalHelp"
      titre="Comparateur de marges"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-6">
          <p class="pb-2">
            Ce comparateur permet de simuler des potentiels de marges en prévision d'un assolement. 
          </p>
          <p class="pb-2">
            Il est réalisé avec des coûts de produits moyens qui sont actualisés régulièrement et des itinéraires techniques types, préconisés par le service agronomie de la coopérative.
          </p>
          <p class="pb-2">
            Les coûts des autres charges spécifiques correspondent à des moyennes constatées.
          </p>
          <p>Vous pouvez établir votre réel coût de production grâce à l'accompagnement d'un conseiller démarche technico-économique. Contactez votre conseiller habituel pour avoir ce conseil personnalisé. </p>
        </div>
      </div>
    </HelpModal>
    <v-dialog
      v-model="isConfirmDeleteModalOpen"
      persistent
      width="500"
    >
      <ConfirmModal
        cancel-text="Non"
        confirm-text="Oui"
        title="Confirmation"
        @cancel="isConfirmDeleteModalOpen = false"
        @confirm="reinitialise()"
      >
        <p>En réinitialisant, vous retrouverez les données par défaut.</p>
        <p>Souhaitez-vous vraiment réinitialiser l’outil ?</p>
      </ConfirmModal>
    </v-dialog>
    <v-dialog
      v-if="isUpdateEngraisModalOpen"
      v-model="isUpdateEngraisModalOpen"
      :scrim="false"
      fullscreen
      transition="slide-x-transition"
    >
      <UpdateEngraisModal
        :engrais="engraisSelected"
        :is-culturial-abonne="abonnements.culturialAbonne"
        :has-droit-ecriture="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) && abonnements.culturialAbonne"
        :loading="loadingUpdate"
        @close="isUpdateEngraisModalOpen = false"
        @openModalAbonnement="openModalAbonnement"
        @updateParametre="updateParametre"
      />
    </v-dialog>
    <v-dialog
      v-if="isUpdateTraitementModalOpen"
      v-model="isUpdateTraitementModalOpen"
      :scrim="false"
      fullscreen
      transition="slide-x-transition"
    >
      <UpdateTraitementModal
        :traitements="traitementSelected"
        :indicateur-pression="indicateurPressionSelected"
        :is-culturial-abonne="abonnements.culturialAbonne"
        :has-droit-ecriture="($roles.hasParamCulturialWriteAccess() || $roles.hasPersoWriteAccess()) && abonnements.culturialAbonne"
        :loading="loadingUpdate"
        @close="isUpdateTraitementModalOpen = false"
        @openModalAbonnement="openModalAbonnement"
        @updateParametre="updateParametre"
      />
    </v-dialog>
  </div>
</template>
      
<script>
import { mapActions, mapGetters } from 'vuex'
import { AgrButton } from '@agrial/ui'
import { isBefore } from 'date-fns'
import BaseInputNumberIncrement from '@/components/form/base-input-number-increment.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import RebondAbonnement from './components/rebond-abonnement.vue'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import UpdateEngraisModal from './components/modal/update-engrais-modal.vue'
import UpdateTraitementModal from './components/modal/update-traitement-modal.vue'
import { groupBy, sortBy } from 'lodash'
import {clone} from '@/utils/clone'
import { colonneCulture, TABLEAU_ERREUR_PAR_RUBRIQUE } from '@/utils/comparateur-marge'
import { formaterRestitutionNutritive } from '@/utils/restitution-nutritive'
import ChargesSpecifiques from './components/charges-specifiques.vue'
import BandeauTotaux from './components/bandeau-totaux.vue'
import CelluleModifiable from './components/cellule-modifiable.vue'

export default {
  name: 'ComparateurMargeAdherent',
  components: { AgrButton, BaseInputNumberIncrement,  BaseLoader, BaseMessageServerError, RebondAbonnement, ConfirmModal, InformationAbonnementModal, HelpModal, UpdateEngraisModal, UpdateTraitementModal, ChargesSpecifiques, BandeauTotaux, CelluleModifiable},
  data () {
    return {
      loading: false,
      loadingUpdate: false,
      erreur: false,
      cultureUneSelected: null,
      cultureDeuxSelected: null,
      cultureTroisSelected: null,
      isDisplayComparaison: false,
      adherentComparateurMargeModifiable: null,
      produits: null,
      engrais: null,
      engraisCultureUne: null,
      engraisCultureDeux: null,
      engraisCultureTrois: null,
      engraisSelected: null,
      computeEngraisCultureUne: null,
      computeEngraisCultureDeux: null,
      computeEngraisCultureTrois: null,
      densiteSemis: null,
      indicateurPressionSelected: null,
      traitementsCultureUne: null,
      traitementsCultureDeux: null,
      traitementsCultureTrois: null,
      traitementSelected: null,
      autresChargesSpecifiques: null,
      indicateursNonChiffresCultureUne: null,
      indicateursNonChiffresCultureDeux: null,
      indicateursNonChiffresCultureTrois: null,
      culturesSelected: null,
      isConfirmDeleteModalOpen: false,
      isOpenModalInformationAbonnement: false,
      isOpenModalCalculPrixDeRevientInformationAbonnement: false,
      isOpenModalBesoinAideInformationAbonnement: false,
      isOpenModalHelp: false,
      isUpdateEngraisModalOpen: false,
      isUpdateTraitementModalOpen: false,
      isDisplayMargeFixed: false,
      paramErreur: null,
      hasErreurProduit: [false, false, false],
      hasErreurIntrant: [false, false, false],
      hasErreurAutresCharges: [false, false, false],
      hasErreurMarge: [false, false, false],
      hasLoadingProduit: [false, false, false],
      hasLoadingDensite: [false, false, false],
      hasLoadingAutresCharges: [false, false, false],
      hasLoadingMarge: [false, false, false]
    }
  },

  computed: {
    ...mapGetters({
      cultures: 'comparateurMarge/cultures',
      adherentComparateurMarge: 'comparateurMarge/adherentComparateurMarge',
      abonnements: 'adherent/abonnements'
    }),
    culturesUneFiltrees () {
      return this.cultures.filter(c=>![this.cultureDeuxSelected, this.cultureTroisSelected].includes(c))
    },
    culturesDeuxFiltrees () {
      return this.cultures.filter(c=>![this.cultureUneSelected, this.cultureTroisSelected].includes(c))
    },
    culturesTroisFiltrees () {
      return this.cultures.filter(c=>![this.cultureDeuxSelected, this.cultureUneSelected].includes(c))
    },
    isComparaisonPossible () {
      return [this.cultureUneSelected, this.cultureDeuxSelected, this.cultureTroisSelected].filter(c=>c == null).length <=1
    },
    traitements () {
      return this.adherentComparateurMarge && this.adherentComparateurMarge.libellesMoyennePressionsTraitementCultures
    },
    computeUniteRendement () {
      let unitesRendements = this.produits ? this.produits[0].filter(tr => tr.comparateurMargeParametre.unite != null).map(tr =>tr.comparateurMargeParametre.unite) : []
      return unitesRendements.every( v => v === unitesRendements[0] ) ? unitesRendements[0] : null
    },
    computeUniteDensiteSemis () {
      let unitedensiteSemisCultureUne = this.densiteSemis && this.densiteSemis[0] ? this.densiteSemis[0].comparateurMargeParametre.unite : null
      let unitedensiteSemisCultureDeux = this.densiteSemis && this.densiteSemis[1] ? this.densiteSemis[1].comparateurMargeParametre.unite : null
      let unitedensiteSemisCultureTrois = this.densiteSemis && this.densiteSemis[2] ? this.densiteSemis[2].comparateurMargeParametre.unite : null
      let unites = [unitedensiteSemisCultureUne, unitedensiteSemisCultureDeux, unitedensiteSemisCultureTrois].filter(tr => tr != null)
      return unites.every( v => v === unites[0] ) ? unitedensiteSemisCultureUne : null
    },
    hasAnyIndicateurNonCalculeRestitutionNutritive () {
      return (this.indicateursNonChiffresCultureUne == null || Object.values(this.indicateursNonChiffresCultureUne.restitutionNutritive).length === 0)
        && (this.indicateursNonChiffresCultureDeux == null || Object.values(this.indicateursNonChiffresCultureDeux.restitutionNutritive).length === 0)
      && (this.indicateursNonChiffresCultureTrois == null || Object.values(this.indicateursNonChiffresCultureTrois.restitutionNutritive).length === 0)
    },
    isDisplayNouveaute () {
      const dateJour = new Date()
      const dateFinNouveaute = new Date(2026, 2, 15)
      return isBefore(dateJour, dateFinNouveaute) 
    },
    // La mise en forme des apports vivait dans le template, en cinq
    // interpolations enchainees par culture, avec des gardes incoherentes :
    // l'azote etait protege, le phosphore a moitie, le potassium jamais.
    restitutionNutritiveCultureUne () {
      return formaterRestitutionNutritive(this.indicateursNonChiffresCultureUne?.restitutionNutritive)
    },
    restitutionNutritiveCultureDeux () {
      return formaterRestitutionNutritive(this.indicateursNonChiffresCultureDeux?.restitutionNutritive)
    },
    restitutionNutritiveCultureTrois () {
      return formaterRestitutionNutritive(this.indicateursNonChiffresCultureTrois?.restitutionNutritive)
    }
  },

  created () {
    this.updateCodeGraineActive(null)
    this.getComparateurMargeCulturesPresentes(false)
      .then(() => {
        this.cultureUneSelected = this.$cookies.get('COMPARATEUR_MARGE_CULTURE_UNE')!= null ? this.cultures.filter(c => c.code === this.$cookies.get('COMPARATEUR_MARGE_CULTURE_UNE'))[0] : null
        this.cultureDeuxSelected = this.$cookies.get('COMPARATEUR_MARGE_CULTURE_DEUX')!= null ? this.cultures.filter(c => c.code === this.$cookies.get('COMPARATEUR_MARGE_CULTURE_DEUX'))[0] : null
        this.cultureTroisSelected = this.$cookies.get('COMPARATEUR_MARGE_CULTURE_TROIS')!= null ? this.cultures.filter(c => c.code === this.$cookies.get('COMPARATEUR_MARGE_CULTURE_TROIS'))[0] : null
        if (this.isComparaisonPossible) {
          this.displayComparaisonMarge()
        }
      })

    this.fetchAbonnements()
    window.addEventListener('scroll', this.handleScroll)
  },

  methods: {
    ...mapActions({
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      getComparateurMargeCulturesPresentes: 'comparateurMarge/getComparateurMargeCulturesPresentes',
      getAdherentComparateurMarge: 'comparateurMarge/getAdherentComparateurMarge',
      fetchAbonnements: 'adherent/fetchAbonnements',
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      updateAdherentComparateurMarge: 'comparateurMarge/updateAdherentComparateurMarge',
      deleteAdherentComparateurMarge: 'comparateurMarge/deleteAdherentComparateurMarge'
    }),
    handleScroll () {
      let elMargeFixed = document.getElementById('marge-fixed')
      let elMarge = document.getElementById('marge')
      if (elMargeFixed != null && elMarge != null) {
        let topMarge = elMarge.getBoundingClientRect().top
        let topMargeFixed = elMargeFixed.getBoundingClientRect().top
        this.isDisplayMargeFixed = topMarge > topMargeFixed
      }
    },
    isLinFibre (typeCulture) {
      return typeCulture && (typeCulture.code === 'LFH' || typeCulture.code === 'LFP')
    },
    uniteRendement (typeCulture) {
      if (this.isLinFibre(typeCulture)) {
        return 'kg/ha'
      } else if (typeCulture.isUniteAfficheeTonneParHectare) {
        return 't/ha'
      } else {
        return 'qx/ha'
      }
    },
    displayComparaisonMarge () {
      this.isDisplayComparaison = true
      this.loading = true
      this.chargeDonnees()
    },
    chargeDonnees () {
      this.erreur = false
      this.culturesSelected = []
      this.culturesSelected.push(this.cultureUneSelected != null ? this.cultureUneSelected.code : null)
      this.culturesSelected.push(this.cultureDeuxSelected != null ? this.cultureDeuxSelected.code : null)
      this.culturesSelected.push(this.cultureTroisSelected != null ? this.cultureTroisSelected.code : null)

      this.getAdherentComparateurMarge(this.culturesSelected)
        .then(() => {
          this.adherentComparateurMargeModifiable = clone(this.adherentComparateurMarge)
          let produitsSorted = sortBy(this.adherentComparateurMargeModifiable.comparateurMargeDonneesAdherent.filter(a => a.comparateurMargeParametre && a.comparateurMargeParametre.typeRubrique.codeRubrique === 'PRODUIT'), ((c) => {
            return c.comparateurMargeParametre.typeRubrique.id
          }))
          this.produits = Object.values(groupBy(produitsSorted, ((p) => {
            return p.comparateurMargeParametre.typeRubrique.id
          })))
          this.produits.forEach(produit => {
            produit.forEach(p => {
              if (p.comparateurMargeParametre.valeurAdmin) {
                return p.comparateurMargeParametre.valeurAdmin.valeur = p.valeurSaisie
              }
            })
          })
          this.densiteSemis = this.adherentComparateurMargeModifiable.comparateurMargeDonneesAdherent.filter(a => a.comparateurMargeParametre && a.comparateurMargeParametre.typeRubrique.codeRubrique === 'DENSITE_SEMIS')
          this.densiteSemis.forEach(densite => {
            if (densite.comparateurMargeParametre.valeurAdmin) {
              return densite.comparateurMargeParametre.valeurAdmin.valeur = densite.valeurSaisie
            }
          })
          let engraisSorted = sortBy(this.adherentComparateurMargeModifiable.comparateurMargeDonneesAdherent.filter(a => a.comparateurMargeParametre && a.comparateurMargeParametre.typeRubrique.codeRubrique === 'ENGRAIS'), ((c) => {
            return c.comparateurMargeParametre.typeRubrique.id
          }))
          engraisSorted.forEach(e => {
            if (e.comparateurMargeParametre.valeurAdmin) {
              return e.comparateurMargeParametre.valeurAdmin.valeur = e.valeurSaisie
            }
          })
          this.engraisCultureUne = this.cultureUneSelected != null ? engraisSorted.filter(e => e.comparateurMargeParametre.typeCulture && e.comparateurMargeParametre.typeCulture.code === this.cultureUneSelected.code) : null
          this.engraisCultureDeux = this.cultureDeuxSelected != null ? engraisSorted.filter(e => e.comparateurMargeParametre.typeCulture && e.comparateurMargeParametre.typeCulture.code === this.cultureDeuxSelected.code) : null
          this.engraisCultureTrois= this.cultureTroisSelected != null ? engraisSorted.filter(e =>e.comparateurMargeParametre.typeCulture && e.comparateurMargeParametre.typeCulture.code === this.cultureTroisSelected.code) : null
          this.computeEngraisCultureUne = this.computeEngrais(this.engraisCultureUne)
          this.computeEngraisCultureDeux = this.computeEngrais(this.engraisCultureDeux)
          this.computeEngraisCultureTrois = this.computeEngrais(this.engraisCultureTrois)
          let traitementsSorted = sortBy(this.adherentComparateurMargeModifiable.comparateurMargeDonneesAdherent.filter(a => a.comparateurMargeParametre && a.comparateurMargeParametre.typeRubrique.codeRubrique === 'TRAITEMENT'), ((c) => {
            return c.comparateurMargeParametre.typeRubrique.id
          }))
          this.traitementsCultureUne = this.cultureUneSelected != null ? traitementsSorted.filter(e => e.comparateurMargeParametre.typeCulture && e.comparateurMargeParametre.typeCulture.code === this.cultureUneSelected.code) : null
          this.traitementsCultureDeux = this.cultureDeuxSelected != null ? traitementsSorted.filter(e => e.comparateurMargeParametre.typeCulture && e.comparateurMargeParametre.typeCulture.code === this.cultureDeuxSelected.code) : null
          this.traitementsCultureTrois = this.cultureTroisSelected != null ? traitementsSorted.filter(e =>e.comparateurMargeParametre.typeCulture && e.comparateurMargeParametre.typeCulture.code === this.cultureTroisSelected.code) : null
          
          let autresChargesSorted = sortBy(this.adherentComparateurMargeModifiable.comparateurMargeDonneesAdherent.filter(a => a.comparateurMargeParametre && a.comparateurMargeParametre.typeRubrique.codeRubrique === 'AUTRE_CHARGE_SPECIFIQUE'), ((c) => {
            return c.comparateurMargeParametre.typeRubrique.id
          }))
          this.autresChargesSpecifiques = Object.values(groupBy(autresChargesSorted, ((a) => {
            return a.comparateurMargeParametre.typeRubrique.id
          })))
          this.autresChargesSpecifiques.forEach(autresChargesSpecifique => {
            autresChargesSpecifique.forEach(a => {
              if (a.comparateurMargeParametre.valeurAdmin) {
                return a.comparateurMargeParametre.valeurAdmin.valeur = a.valeurSaisie
              }
            })
          })
          let indicateursNonChiffresSorted = sortBy(this.adherentComparateurMarge.indicateursNonChiffres, ((c) => {
            return c.id
          }))
          this.indicateursNonChiffresCultureUne = this.cultureUneSelected != null ? indicateursNonChiffresSorted.filter(e => e.typeCulture && e.typeCulture.code === this.cultureUneSelected.code)[0] : null
          this.indicateursNonChiffresCultureDeux = this.cultureDeuxSelected != null ? indicateursNonChiffresSorted.filter(e => e.typeCulture && e.typeCulture.code === this.cultureDeuxSelected.code)[0] : null
          this.indicateursNonChiffresCultureTrois = this.cultureTroisSelected != null ? indicateursNonChiffresSorted.filter(e =>e.typeCulture && e.typeCulture.code === this.cultureTroisSelected.code)[0] : null
        })
        .catch (() => {
          this.erreur = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    reinitialise () {
      this.$cookies.remove('COMPARATEUR_MARGE_CULTURE_UNE')
      this.$cookies.remove('COMPARATEUR_MARGE_CULTURE_DEUX')
      this.$cookies.remove('COMPARATEUR_MARGE_CULTURE_TROIS')
      this.cultureUneSelected = null
      this.cultureDeuxSelected = null
      this.cultureTroisSelected = null
      this.deleteAdherentComparateurMarge()
        .then(() => {
          this.culturesSelected = null
          this.produits = null
          this.densiteSemis = null
          this.engraisCultureUne = null
          this.engraisCultureDeux = null
          this.engraisCultureTrois = null
          this.computeEngraisCultureUne = null
          this.computeEngraisCultureDeux = null
          this.computeEngraisCultureTrois = null
          this.autresChargesSpecifiques = null
          this.isConfirmDeleteModalOpen = false
          this.isDisplayComparaison = false
        })
        .catch (() => {
          this.erreur = true
        })

    },
    selectCulture () {
      this.$cookies.set('COMPARATEUR_MARGE_CULTURE_UNE', this.cultureUneSelected!= null ? this.cultureUneSelected.code: null)
      this.$cookies.set('COMPARATEUR_MARGE_CULTURE_DEUX', this.cultureDeuxSelected!= null ? this.cultureDeuxSelected.code: null)
      this.$cookies.set('COMPARATEUR_MARGE_CULTURE_TROIS', this.cultureTroisSelected!= null ? this.cultureTroisSelected.code: null)

      if (this.isDisplayComparaison) {
        this.chargeDonnees()
      }
    },
    computeEngrais (engrais) {
      let result = null
      if(engrais && engrais.length) {
        result = ''
        engrais.forEach((element, index) => {
          if (element.comparateurMargeParametre.typeRubrique && element.comparateurMargeParametre.typeRubrique.statut ==='OBLIGATOIRE') {
            result += element.valeurSaisie + 'u' + element.comparateurMargeParametre.typeRubrique.libelleSousRubrique + `${index === 2 ? '' : ', '}`
          }
          
        })
      }
      return result
    },
    changeEngrais (engrais) {
      this.engraisSelected = engrais
      this.isUpdateEngraisModalOpen = true
    },
    changeTraitement (traitement, indicateurPression) {
      this.traitementSelected = traitement
      this.indicateurPressionSelected = indicateurPression
      this.isUpdateTraitementModalOpen = true
    },
    getMsgInfoMaisGrainOuSorgo (parametre, libelleSousRubrique) {
      let result = null
      if (parametre.comparateurMargeParametre.typeCulture.code === 'MG' || parametre.comparateurMargeParametre.typeCulture.code === 'SGG') {
        if (libelleSousRubrique === 'Rendement') {
          result = 'Rendement sec'
        } else if (libelleSousRubrique === 'Prix de vente') {
          result = 'Prix net de frais de séchage '
        } else {
          result = null
        }
      }
      return result 
    },
    openModalAbonnement () {
      if (!this.abonnements.culturialAbonne) {
        this.isOpenModalInformationAbonnement = true
        this.incrementerAccesSouscriptionAbonnement('COMPARATEUR_MARGE')
      }
    },
    updateParametre (parametres) {
      this.loadingUpdate = true
      parametres.forEach((parametre, index) => {
        if (index < parametres.length - 1) {
          this.updateAdherentComparateurMarge({ parametre: parametre, cultures: this.culturesSelected })
          .then(() => {
            this.chargeDonnees()
          })
        }
        if (index === parametres.length - 1) {
          this.updateAdherentComparateurMarge({ parametre: parametre, cultures: this.culturesSelected })
            .then(() => {
              this.chargeDonnees()
            })
            .finally(() => {
              this.loadingUpdate = false
              this.isUpdateEngraisModalOpen = false
              this.isUpdateTraitementModalOpen = false
            })
        }
      })
    },
    hasErreurSaisie (parametre) {
      return this.paramErreur!= null && parametre.id !== this.paramErreur.id
    },
    onUpdate (param, parametre) {
      if (parametre === this.paramErreur || this.paramErreur === null) {
        parametre.valeurSaisie = param
        this.loadingUpdate = true
        this.computeSaisieLoading(true, parametre.comparateurMargeParametre.typeRubrique.codeRubrique, parametre.comparateurMargeParametre.typeCulture.code)
        this.updateAdherentComparateurMarge({ parametre: parametre, cultures: this.culturesSelected })
          .then(() => {
            this.computeSaisieErreur(false, parametre.comparateurMargeParametre.typeRubrique.codeRubrique, parametre.comparateurMargeParametre.typeCulture.code)
            this.paramErreur = null
          })
          .catch(() => {
            this.computeSaisieErreur(true, parametre.comparateurMargeParametre.typeRubrique.codeRubrique, parametre.comparateurMargeParametre.typeCulture.code)
            this.paramErreur = parametre
          })
          .finally(() => {
            this.loadingUpdate = false
            this.computeSaisieLoading(false, parametre.comparateurMargeParametre.typeRubrique.codeRubrique, parametre.comparateurMargeParametre.typeCulture.code)
          })
      }
    },
    hasSameValue (parametre) {
      return parametre.valeurDefaut === parametre.valeurAdmin.minimum && parametre.valeurDefaut === parametre.valeurAdmin.maximum
    },

    computeSaisieErreur (isErreur, codeRubrique, codeCulture) {
      // Chaque rubrique alimente son propre tableau d'erreurs, et toutes
      // alimentent hasErreurMarge : une erreur de saisie, ou qu'elle soit,
      // invalide la marge calculee pour cette colonne.
      const tableauErreur = TABLEAU_ERREUR_PAR_RUBRIQUE[codeRubrique]
      if (tableauErreur == null) {
        return
      }
      const colonne = colonneCulture(
        codeCulture,
        this.cultureUneSelected?.code,
        this.cultureDeuxSelected?.code
      )
      this[tableauErreur].splice(colonne, 1, isErreur)
      this.hasErreurMarge.splice(colonne, 1, isErreur)
    },
    computeSaisieLoading (isLoading, codeRubrique, codeCulture) {
      if (codeRubrique === 'PRODUIT') {
        if (codeCulture === this.cultureUneSelected.code) {
          this.hasLoadingProduit.splice(0, 1, isLoading)
          this.hasLoadingMarge.splice(0, 1, isLoading)
        } else if (codeCulture === this.cultureDeuxSelected.code) {
          this.hasLoadingProduit.splice(1, 1, isLoading)
          this.hasLoadingMarge.splice(1, 1, isLoading)
        } else {
          this.hasLoadingProduit.splice(2, 1, isLoading)
          this.hasLoadingMarge.splice(2, 1, isLoading)
        }
      }
      if (codeRubrique === 'DENSITE_SEMIS') {
        if (codeCulture === this.cultureUneSelected.code) {
          this.hasLoadingDensite.splice(0, 1, isLoading)
          this.hasLoadingMarge.splice(0, 1, isLoading)
        } else if (codeCulture === this.cultureDeuxSelected.code) {
          this.hasLoadingDensite.splice(1, 1, isLoading)
          this.hasLoadingMarge.splice(1, 1, isLoading)
        } else {
          this.hasLoadingDensite.splice(2, 1, isLoading)
          this.hasLoadingMarge.splice(2, 1, isLoading)
        }
      }
      if (codeRubrique === 'AUTRE_CHARGE_SPECIFIQUE') {
        if (codeCulture === this.cultureUneSelected.code) {
          this.hasLoadingAutresCharges.splice(0, 1, isLoading)
          this.hasLoadingMarge.splice(0, 1, isLoading)
        } else if (codeCulture === this.cultureDeuxSelected.code) {
          this.hasLoadingAutresCharges.splice(1, 1, isLoading)
          this.hasLoadingMarge.splice(1, 1, isLoading)
        } else {
          this.hasLoadingAutresCharges.splice(2, 1, isLoading)
          this.hasLoadingMarge.splice(2, 1, isLoading)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-height {
  height: 80px;
}
.fixed-height-no-data {
  height: 60px;
}
.fixed-width {
  width: 360px;
}
.max-width-105 {
  width: 105px;
}
.max-width-165 {
  width: 165px;
}
.width-100 {
  width: 100%;
}
.background-page {
  background: white;
}
.btn-reinit {
  cursor: pointer;
}
.border {
  border: 2px solid var(--v-secondary-base);
}
.entete-marge {
  border-radius: 25px 25px 0 0;
  margin-top: -2px;
  background-color: var(--v-secondary-base);
}
.alert-fixed {
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 80px;
  right: 13px;
}
.alert-fixed-mobile {
  z-index: 100;
  position: fixed;
  bottom: 55px;
  left: 10px;
  right: 10px;
}
.z-index-marge-fixed {
  z-index: -1;
}
.v-input input {
  max-height: 0px !important;
}
.padding-top {
  padding-top: 0.2rem;
}
.position-rebond {
  position: absolute;
  top: 0;
  right: 8px;
}
</style>